import React from "react";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import '@/Scss/Site/Main/teasers.scss';

const Teasers = (props) => {
    const {teasers = []} = props;

    if (teasers.length === 0) return null;

    return (
        <div className={`teasers`}>
            {teasers.map(({id, svgName, text, link}) => {
                return <Link key={id} href={link} className={`teasers__item`}>
                    <Svg id={svgName} className={`svg--${svgName}`} />
                    <p className={`teasers__text`}>{text}</p>
                </Link>
            })}
        </div>
    );
}

export default Teasers;
